import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useLegacyArticleHeaderGet = (articleSlug, params = null) => {
  const skip = articleSlug === "undefined" || !articleSlug;
  const queryString = new URLSearchParams(params).toString();
  let requestUrl = `${MONOLITH_ORIGIN}/api/v2/articleheader/${articleSlug}/`;
  if (queryString) requestUrl += `?${queryString}`;
  return useRestQuery(requestUrl, { skip });
};

export default useLegacyArticleHeaderGet;
